import coreController from "./coreController";

import BookingModule from "./bookings/module";
import BasketModule from "./basket/module";
import BasketFixedModule from "./basket-fixed/module";

import ResourceModule from "./resources/module";
import BookingPeriodsModule from "./booking-periods/module";
import UserModule from "./users/module";
import RoleModule from "./roles/module";
import LocationModule from "./locations/module";
import SearchModule from "./search/module";
import ScrollModule from "./scroll/module";
// import CapModule from "./capabilities/module";

const modul = angular
    .module("general", [
        BasketModule,
        BasketFixedModule,
        BookingModule,
        BookingPeriodsModule,
        ResourceModule,
        UserModule,
        RoleModule,
        LocationModule,
        SearchModule,
        ScrollModule,
        // CapModule,
    ])
    .controller("coreController", coreController);

export default modul.name;
